import { render, staticRenderFns } from "./LProjectSessionsList.vue?vue&type=template&id=20665924&scoped=true&"
import script from "./LProjectSessionsList.vue?vue&type=script&lang=js&"
export * from "./LProjectSessionsList.vue?vue&type=script&lang=js&"
import style0 from "./LProjectSessionsList.vue?vue&type=style&index=0&id=20665924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20665924",
  null
  
)

export default component.exports